import { getMonthToDateRange } from '@/utils/date';
import {
  ACTIVE_STATUS_CHOICES,
  parseEnumFilter,
  parseNumberFilter,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import { ZM_STATUS_FILTER_KEY } from '../constants/dashboard.constants';
import type { DcrDashboardListSearch, DcrDashboardSearch } from '../types/dashboard.types';

export function toDcrDashboardFilterValues(search: DcrDashboardSearch): Record<string, string> {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    [ZM_STATUS_FILTER_KEY]: toFilterText(search.zmStatus),
    reportingMemberId: toFilterText(search.reportingMemberId),
    companyId: toFilterText(search.companyId),
    departmentId: toFilterText(search.departmentId),
    ...toGeoFilterValues(search),
  };
}

export function toDcrDashboardFilterSearch(values: Record<string, string>): DcrDashboardSearch {
  return {
    ...toPeriodSearch(values),
    zmStatus: parseEnumFilter(values[ZM_STATUS_FILTER_KEY], ACTIVE_STATUS_CHOICES),
    reportingMemberId: parseNumberFilter(values.reportingMemberId),
    companyId: parseNumberFilter(values.companyId),
    departmentId: parseNumberFilter(values.departmentId),
    ...toGeoSearch(values),
  };
}

export function toDcrDrillSearch({
  search: _search,
  ...drillSearch
}: DcrDashboardListSearch): DcrDashboardSearch {
  return drillSearch;
}
